"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const issue_mapper_1 = require("../utils/issue-mapper");
const universal_format_utils_1 = require("../utils/universal-format-utils");
const get_screenshot_url_1 = require("../utils/get-screenshot-url");
function jsonUniversal(test, manifests, issues, additionalProperties, exportFormat = 'string') {
    const issueSummary = (0, universal_format_utils_1.getIssueSummary)(issues);
    const igtSummary = (0, universal_format_utils_1.getIgtSummary)(test, manifests, issues);
    const failedRules = (0, universal_format_utils_1.getIssueRules)(issues);
    const needsReview = (0, universal_format_utils_1.getIssueRules)(issues, true);
    const startDate = additionalProperties.startDate
        ? new Date(additionalProperties.startDate).toISOString()
        : null;
    const endDate = additionalProperties.endDate
        ? new Date(additionalProperties.endDate).toISOString()
        : null;
    const axeVersion = test.metadata.axeVersion;
    const bestPracticesEnabled = additionalProperties.bestPracticesEnabled;
    const experimentalEnabled = additionalProperties.experimentalEnabled;
    const exportData = {
        url: test.url,
        extensionVersion: additionalProperties.extensionVersion,
        axeVersion,
        standard: additionalProperties.standard,
        testingStartDate: startDate,
        testingEndDate: endDate,
        bestPracticesEnabled,
        experimentalEnabled,
        issueSummary,
        remainingTestingSummary: {
            run: !!test.manual_tests_completed_at
        },
        igtSummary,
        failedRules,
        needsReview,
        source: additionalProperties.source,
        testDetails: {
            testId: test.id,
            testName: test.name || '',
            axeVersion,
            engine: additionalProperties.engine,
            standard: additionalProperties.standard,
            createdBy: additionalProperties.createdBy || null,
            startDate,
            endDate,
            bestPracticesEnabled,
            experimentalEnabled,
            integrationTestId: additionalProperties.integrationTestId || null
        },
        allIssues: issues.map(issue => {
            return {
                ...(0, issue_mapper_1.mapAxeExtensionIssueToUniversalIssue)(issue),
                appIdentifier: issue.appIdentifier,
                screenTitle: issue.screenTitle,
                foundBy: issue.foundBy || additionalProperties.foundBy,
                testUrl: issue.testUrl || test.url,
                analyzedValues: issue.analyzedValues,
                axeVersion: issue.axeVersion || axeVersion,
                testPageTitle: issue.testPageTitle || test.test_page_title,
                screenshotURL: (0, get_screenshot_url_1.getScreenshotUrl)(additionalProperties.baseScreenshotURL, issue.screenshotId)
            };
        })
    };
    if (exportFormat === 'json') {
        return exportData;
    }
    return JSON.stringify(exportData).replace(/\\n/g, '\\\\n');
}
exports.default = jsonUniversal;
//# sourceMappingURL=json-universal.js.map